import React from 'react'

export default function () {
  return <img alt='' src='/images/blank.jpg' width='80px' height='80px' />
}
